import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, {HttpStatusCode} from "axios";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import { HeadersUtil } from "app/utils/headersUtil";
import { ResponseApi, ResponseResultCode } from "app/model/response-api";
import { UserMenuModel } from "app/model/ua/user-menu";
import MenuUtil from "app/utils/menuUtil";

const initialState: any = {
  currentMenu: undefined,
  rootMenu: undefined,
  menus: [],
  flatMenus: [],
};

export const getUserMenus = createAsyncThunk("menu/userMenu", async (_userId: string) => {
  const emksSysClCd = 1;
  const url = process.env.REACT_APP_URL_CO + "/menu/access";
  const param = { emksSysClCd };
  const response = await axios.get(ApiUrlUtil.buildQueryString(url, param), {
    headers: HeadersUtil.getHeadersAuth(),
  });
  if (response && response.status === HttpStatusCode.Ok) {
    return response.data;
  }
});

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setCurrentMenu: (state, action) => {
      state.currentMenu = action.payload.currentMenu;
      state.rootMenu = action.payload.rootMenu;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserMenus.pending, () => {})
      .addCase(getUserMenus.fulfilled, (state, action: any) => {
        const response = action.payload as ResponseApi<UserMenuModel[]>;
        if (response && ResponseResultCode.Y === response.resultCode) {
          const navigationMenus = MenuUtil.filterNavigationMenus(response.data ?? []);
          state.menus = navigationMenus;
          state.flatMenus = MenuUtil.convertToFlatMenuArray(navigationMenus);
        }
      })
      .addCase(getUserMenus.rejected, (state) => {
        state.menus = [];
      });
  },
});

export default menuSlice.reducer;
export const { setCurrentMenu } = menuSlice.actions;